// ReSharper disable StringLiteralTypo
// ReSharper disable IdentifierTypo
// ReSharper disable UndeclaredGlobalVariableUsing
(function($, _, root) {
    'use strict';
    var assetId = 'uc214-detailedsearch';
    var utils = new Utils();

    $(function domReady() {
        if (root.umwAssets && root.umwAssets[assetId]) {
            root.umwAssets[assetId].forEach(function(contextModel) {
                if (contextModel) {
                    var mainPanelId = contextModel.mainPanelID;
                    var $mainPanel = $('#' + mainPanelId);

                    if ($mainPanel.length === 1) {
                        var searchProccessor = new SearchProccessor($mainPanel, contextModel, utils);
                        searchProccessor.init();
                    } else if ($mainPanel.length === 0) {
                        console.warn(assetId + ': detailed search main panel element was not found by id#' + mainPanelId);
                    } else {
                        console.warn(assetId + ': found > 1 detailed search main panel elements with id#' + mainPanelId);
                    }
                }
            });
        }
    });

    function SearchProccessor($mainPanel, contextModel, utils) {
        var _$body = $('body');
        var _$mainPanel = $mainPanel;
        var _contextModel = contextModel;
        var _utils = utils;

        var _isFirstLoading = true;
        var _cache = { empty: {} };
        var _$searchInput, _$popupContainer, _$searchClearBtn;
        var _searchDelay = 1000;
        var _searchInProcess = false;
        var _productListController = null;
        var _clearBtnClick = false;

        function _init() {
            _$searchClearBtn = _$mainPanel.find('.js-search-clear-input-btn');
            _$searchInput = _$mainPanel.find('.js-search-input');

            if (contextModel.alternativePopupContainerSelector) {
                _$popupContainer = $(contextModel.alternativePopupContainerSelector);
            } else {
                _$popupContainer = $('.js-detailed-search-popup');
            }

            $(document).on('click',
                function (e) {
                    if (!_$searchInput[0].contains(e.target) && !_$popupContainer[0].contains(e.target)) {
                        if (_clearBtnClick) {
                            _clearBtnClick = false;
                        } else if (root.PubSub) {
                            root.PubSub.publish('popup.unlockRender');
                        }

                        _togglePopup(false);
                    }
                });

            /* No need in submit button. Was requested to use clear button instead. Don't delete - can be used in future projects.
            var _$searchBtn = _$mainPanel.find('.js-search-btn');
            _$searchBtn.on('click',
                function(e) {
                    var term = $.trim(_$searchInput.val());
                    if (term && term.length && term.length >= _contextModel.minTermLength) {
                        root.location = root.R + _contextModel.searchUrl + encodeURIComponent(term);
                    } else {
                        e.preventDefault();
                    }
                });
            */

            _$searchClearBtn.on('click',
                function () {
                    _clearBtnClick = true;
                    _$searchInput.val('').focus();
                    _$mainPanel.attr('data-input-has-term', 'false');
                }
            );

            _$searchInput
                .on('keyup',
                    function (e) {
                        if (e.key && typeof (e.key) !== 'undefined' && e.key.length && e.key !== 'Unidentified' && !e.repeat) {
                            var term = $.trim(_$searchInput.val());
                            // Has terms data required to show different icons depends on input state.
                            if (term && term.length && term.length > 0) {
                                _$mainPanel.attr('data-input-has-term', 'true');
                            } else {
                                _$mainPanel.attr('data-input-has-term', 'false');
                            }
                            if (e.key.length === 1 || e.key === 'Backspace' || e.key === 'Delete') {
                                if (_searchInProcess) {
                                    return;
                                }
                                _searchInProcess = true;
                                setTimeout(function () {
                                    _search();
                                    _searchInProcess = false;
                                }, _searchDelay);
                            }
                        }
                    })
                .on('keypress', function (e) {
                    if (e.key && typeof (e.key) !== 'undefined' && e.key.length && e.key !== 'Unidentified' && !e.repeat && e.key === 'Enter') {
                        e.preventDefault();
                        var term = $.trim(_$searchInput.val());
                        if (term && term.length && term.length) {
                            root.location = root.R + _contextModel.searchUrl + encodeURIComponent(term);
                        }
                    }
                })
                .on('focus',
                    function () {
                        if (root.PubSub) {
                            root.PubSub.publish('popup.lockRender');
                        }
                        _search();
                    });
        }

        function _generatePopupHtml(searchResultModel) {
            if (_contextModel.popupTemplate) {
                return _.template(_contextModel.popupTemplate, searchResultModel);
            } else {
                console.error('Popup template does not exists in the context model.');
                return '';
            }
        }

        function _togglePopup(showOrHide) {
            if(showOrHide) {
                _$popupContainer.removeClass('hidden');
                _$body.addClass('detailed-search-modal-is-shown');
            } else {
                _$popupContainer.addClass('hidden');
                _$body.removeClass('detailed-search-modal-is-shown');
            }
        };

        function _setLoadingUI() {
            if (_isFirstLoading) {
                _isFirstLoading = false;

                var popupHtml = _generatePopupHtml({ isLoading: true });
                _$popupContainer.empty();
                _$popupContainer.append(popupHtml);
                _togglePopup(true);
            }
        }

        function _proccessSearchResult(searchResultModel, searchInput) {
            _$popupContainer.empty();

            var searchResultModelEx = $.extend(searchResultModel,
                {
                    isLoading: false,
                    searchHref: root.R + _contextModel.searchUrl + encodeURIComponent(searchInput),
                    labels: _contextModel.labels,
                });

            _.each(searchResultModelEx.documentsSection.documents, function (document) {
                // Strip html tags before embedding it into the markup. Documents can contain html which is not compatible with simple text presentation for teaser in detailed search popup.
                document.teaser = document.teaser.replace(/(<([^>]+)>)/gi, '');
            });
            var popupHtml = _generatePopupHtml(searchResultModelEx);
            _$popupContainer.empty();
            _$popupContainer.append(popupHtml);

            if (searchResultModelEx.productsSection.productListAssetContext) {
                var productListAssetContext = JSON.parse(searchResultModelEx.productsSection.productListAssetContext);
                if (productListAssetContext &&
                    root.createProductListController &&
                    typeof (root.createProductListController) == 'function') {
                    productListAssetContext.skipFilterEvents = true;
                    _productListController = createProductListController(productListAssetContext);
                    if (_productListController) {
                        _productListController.init();
                    }
                }
            }

            if (searchResultModelEx.productsSection.productsCount && _$popupContainer.find('.lipscore-rating-small').length && lipscore) {
                lipscore.reInitWidgets();
            }

            _togglePopup(true);
        }

        function _search() {
            var searchInput = $.trim(_$searchInput.val());
            if (searchInput && searchInput.length && searchInput.length >= _contextModel.minTermLength) {

                _setLoadingUI();

                var cacheKey = searchInput;
                if (_cache[cacheKey]) {
                    _proccessSearchResult(_cache[cacheKey], searchInput);
                } else {
                    $.ajax({
                            url: root.R + 'handlers/public/ItemSearch.ashx',
                            type: 'GET',
                            data: {
                                action: 'detailedsearch',
                                term: searchInput,
                                productListResultsCount: _contextModel.productListResultsCount,
                                pageResultsCount: _contextModel.pageResultsCount,
                                documentResultsCount: _contextModel.documentResultsCount,
                                eventResultsCount: _contextModel.eventResultsCount,
                                imageWidth: _contextModel.imageWidth
                            }
                        })
                        .success(function (result) {
                            _cache[cacheKey] = result;
                            _proccessSearchResult(result, searchInput);
                        })
                        .error(function (errResp) {
                            var errorMessage = _utils.extractErrorMessageFromResponse(errResp);
                            console.error('Failed to make search request with term "' + searchInput + '". ', errorMessage);
                        });
                }
            }
        }

        return { init: _init }
    }

    function Utils() {
        return {
            extractErrorMessageFromResponse: function(errorResponse) {
                var message;
                if (typeof errorResponse === 'object' && errorResponse !== null) {
                    // Extract error message
                    try {
                        var parsedResponseBody = JSON.parse(errorResponse.responseText);
                        message = parsedResponseBody.ExceptionMessage ? parsedResponseBody.ExceptionMessage : (parsedResponseBody.Message ? parsedResponseBody.Message : errorResponse.statusText);
                    } catch (e) {
                        message = errorResponse.statusText;
                    }
                } else {
                    message = errorResponse;
                }

                return message;
            }
        }
    }

})(jQuery, _, window);